import { render, staticRenderFns } from "./CardGridSection.vue?vue&type=template&id=561df7b2&scoped=true"
import script from "./CardGridSection.vue?vue&type=script&lang=js"
export * from "./CardGridSection.vue?vue&type=script&lang=js"
import style0 from "./CardGridSection.vue?vue&type=style&index=0&id=561df7b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561df7b2",
  null
  
)

export default component.exports